import { Component } from '@angular/core';

@Component({
  selector: 'app-new-label',
  templateUrl: './new-label.component.html',
  styleUrls: ['./new-label.component.scss'],
  standalone: false
})
export class NewLabelComponent {}
